import { useStoreLogger } from '../logger'
import { GetOrderEntryConnectorUrl } from '@/stores/SettingsStore.ts'
import { ApiPost, ApiGet } from './Common.ts'

export interface IMarketingOptInCreate {
  emailAddress: string
  dataUsage?: string
  shaSessionGuid?: number
}

export interface IMarketingOptInCreateResponse {
  aoeOptInId: number
  initialOptIn: Date
  lastModifiedTime: Date
}

export interface IMarketingOptInGet {
  emailAddress: string
}

export interface IMarketingOptInGetResponse {
  aoeOptInId: number
  shaSessionGuid?: number
  lastModifiedTime: Date
  dataUsage?: string
  emailAddress: string
  initialOptIn: Date
  confirmOptIn?: Date
  optOut?: Date
}

export interface IMarketingOptInConfirm {
  emailAddress: string
}

export interface IMarketingOptInConfirmResponse {
  confirmOptIn?: Date
  lastModifiedTime: Date
}

export async function MarketingOptInCreate(request: IMarketingOptInCreate) {
  const logger = useStoreLogger()
  logger.debug('MarketingOptInCreate', request)
  const url = await GetOrderEntryConnectorUrl('OptInCreate')
  return ApiPost(url, request)
}

export async function MarketingOptInGet(request: IMarketingOptInGet) {
  const logger = useStoreLogger()
  logger.debug('MarketingOptInGet', request)
  const url = await GetOrderEntryConnectorUrl('OptInGet')
  return ApiGet(url, request)
}

export async function MarketingOptInConfirm(request: IMarketingOptInConfirm) {
  const logger = useStoreLogger()
  logger.debug('MarketingOptInConfirm', request)
  const url = await GetOrderEntryConnectorUrl('OptInConfirm')
  return ApiPost(url, request)
}
